"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitHubAppInstallStatus = void 0;
var GitHubAppInstallStatus;
(function (GitHubAppInstallStatus) {
    // Install initiated and the PENDING connection was recorded; activation is webhook-driven.
    GitHubAppInstallStatus["PENDING"] = "pending";
    // The installer is not an org owner and could only *request* the install. GitHub fires no
    // callback when an owner later approves it, so unlike PENDING this will not resolve by polling.
    // The user completes the claim later through the standalone authorization recovery flow.
    GitHubAppInstallStatus["AWAITING_APPROVAL"] = "awaiting_approval";
    GitHubAppInstallStatus["FAILED"] = "failed";
})(GitHubAppInstallStatus || (exports.GitHubAppInstallStatus = GitHubAppInstallStatus = {}));
